<template>
  <div :class="personClass">
    <v-container v-if="!$store.state.ui.loading">
      <div v-if="errorMessage">
        {{ errorMessage }}
      </div>
      <div v-else-if="!currentUserCan('viewPerson')">
        <v-alert>
          You do not have sufficient permission to view this screen. Please
          contact your administrator.
        </v-alert>
      </div>
      <div v-else>
        <pharmacist
          :person-id="$route.params.id"
          :key="'person_' + $route.params.id"
          id="personal"
          @error="handleError"
        />

        <addresses
          :person-id="$route.params.id"
          :key="'address_list_' + $route.params.id"
          format="tabs"
          id="addresses"
        />

        <certs
          :person-id="$route.params.id"
          :key="'cert_list_' + $route.params.id"
          format="list"
          id="certs"
        />

        <scope-conditions
          :person-id="$route.params.id"
          :key="'scopeconditions_list_' + $route.params.id"
          format="tabs"
          id="conditions"
        />

        <scopesofpractice
          :person-id="$route.params.id"
          :key="'scopeofpractice_list_' + $route.params.id"
          format="list"
          id="scopes"
        />

        <online-forms
          :person-id="$route.params.id"
          :key="'onlineForms_' + $route.params.id"
          id="forms"
        />

        <payments
          :person-id="$route.params.id"
          :key="'payments_list_' + $route.params.id"
          format="list"
          id="payments"
        />

        <qualifications
          :person-id="$route.params.id"
          :key="'qualifications_list_' + $route.params.id"
          format="list"
          id="quals"
        />

        <verifications
          :person-id="$route.params.id"
          :key="'verifications_list_' + $route.params.id"
          format="list"
          id="verifications"
        />

        <accreditations
          :person-id="$route.params.id"
          :key="'accreditations_list_' + $route.params.id"
          format="list"
          id="accreditations"
        />
        
        <!-- <cases
          :person-id="$route.params.id"
          :key="'case_list_' + $route.params.id"
          format="list"
          id="compliance"
        /> -->
      </div>
    </v-container>
  </div>
</template>

<script>
// import personDetail from "@/components/people/single.vue";
import pharmacist from "@/components/pharmacists/detail.vue";
import addresses from "@/components/addresses/list";
import certs from "@/components/certs/list.vue";
import scopeConditions from "@/components/register/conditions/list.vue";
import scopesofpractice from "@/components/register/scopes/list.vue";
import onlineForms from "@/components/online-forms/applications.vue";
import payments from "@/components/payments/list.vue";
import qualifications from "@/components/register/qualifications/list.vue";
import verifications from "@/components/register/verifications/list.vue";
import accreditations from "@/components/register/accreditations/list.vue";
import cases from "@/components/register/cases/list.vue"
export default {
  data() {
    return {
      pharmacist: {
        id: this.$route.params.id
      },
      errorMessage: ""
    };
  },
  methods: {
    handleError(e) {
      if (e.message.includes(404)) {
        this.errorMessage = "Practitioner not found";
      }
    }
  },
  computed: {
    personClass() {
      return `referralid-${this.$store.getters.current?.referralid}`;
    }
  },
  watch: {
    "$route.params": {
      handler(params) {
        this.errorMessage = "";
        document.title = `#${params.id} - ${process.env.VUE_APP_TITLE}`;
      },
      immediate: true,
      deep: true
    }
  },

  components: {
    pharmacist,
    payments,
    certs,
    scopesofpractice,
    addresses,
    qualifications,
    onlineForms,
    scopeConditions,
    verifications,
    accreditations,
    cases
  }
};
</script>

<style>
/* Registration = 203 */
.referralid-203 {
  border: yellowgreen solid 5px !important;
}

/* Compliance= 204 */
.referralid-204 {
  border: pink solid 5px !important;
}
/* Registrar= 205 */
.referralid-205 {
  border: red solid 3px !important;
}
/* Accounts = 206 */
.referralid-206 {
  border: blue solid 4px !important;
}
/* Learning & Assesment = 207 */
/* Audit = 211 */
.referralid-211 {
  border: purple solid 4px !important;
}
</style>
